module.exports = __webpack_public_path__ + "static/media/service_doc_icon.f85db642.svg";